import React, { useContext } from 'react';
import { observer } from 'mobx-react';
import { useTranslation } from 'react-i18next';
import { Box } from '@wix/design-system';
import {
  faEnforcementAllFlowsSrc5Evid237,
  faEnforcementUserExcludedSrc18Evid2,
} from '@wix/bi-logger-identity-data/v2';
import ConfirmExitIllustration from '../../../assets/images/confirmExit.svg';
import { AppContextProvider } from '../../AppLoader';
import { EnforcementCard } from './EnforcementCard';
import { ButtonWithLoader } from '../../ButtonWithLoader/ButtonWithLoader';
import { ThemedButton } from '../../ThemedComponents';

export const ConfirmExitEnforcementRedesign: React.FC = observer(() => {
  const {
    rootStore: {
      postLoginStore: { premiumUsers2FaEnforcementStore: store },
      displayStore,
    },
  } = useContext(AppContextProvider);
  const { t } = useTranslation();
  const { preset } = displayStore;

  const onStay = () => {
    store.sendBiEvent(
      faEnforcementAllFlowsSrc5Evid237({
        screenName: 'exclude option',
        button_name: 'Add verification method',
      }),
    );
    store.navigationStore.navigateToEnforcement();
  };

  const onLeave = () => {
    store.sendBiEvent(
      faEnforcementAllFlowsSrc5Evid237({
        screenName: 'exclude option',
        button_name: 'Continue to site',
      }),
    );
    store.sendBiEvent(
      faEnforcementUserExcludedSrc18Evid2({
        is_success: true,
        user_id: store.postLoginStore.userDetails.guid,
      }),
    );
    store.postLoginStore.proceedToPostAuthUrl(
      'confirmed exit from enforcement',
    );
  };

  return (
    <EnforcementCard
      priority="primary"
      title={t('confirm.exit.enforcement.title')}
      subtitle={t('confirm.exit.enforcement.text')}
      primaryButton={
        <ButtonWithLoader
          skin={preset.buttonDesign?.skin ?? 'standard'}
          onClick={onLeave}
        >
          {t('confirm.exit.enforcement.secondary.button.text')}
        </ButtonWithLoader>
      }
      secondaryButton={
        <ThemedButton
          priority="secondary"
          size="large"
          fullWidth
          onClick={onStay}
          style={{
            ...(preset.buttonDesign?.height && {
              height: displayStore.buttonHeight,
            }),
            ...(displayStore.buttonFontSize && {
              ['--wds-font-size-body-medium' as string]:
                displayStore.buttonFontSize,
            }),
          }}
        >
          {t('confirm.exit.enforcement.primary.button.text')}
        </ThemedButton>
      }
    >
      <Box align="center" width="100%">
        <ConfirmExitIllustration />
      </Box>
    </EnforcementCard>
  );
});
